import listPage from "./listPage";

export default [
    listPage,
  ] 

  